import { render, staticRenderFns } from "./model-table.vue?vue&type=template&id=49676cab&scoped=true&"
import script from "./model-table.vue?vue&type=script&lang=ts&"
export * from "./model-table.vue?vue&type=script&lang=ts&"
import style0 from "./model-table.vue?vue&type=style&index=0&id=49676cab&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49676cab",
  null
  
)

export default component.exports